import src from "./iphone-frame.png"
export default { src, width: 1310, height: 2710 }
